export function getBenefits(state) {
  return state.benefits;
}

export function getBenefitGroup(state, benefit_group) {
  if (state.benefits != "undefined" && state.benefits && state.benefits.length) {
    return state.benefits.filter(
      benefit => benefit.benefit_type == benefit_group
    )
  }
}

export function getSelectedBenefit(state) {
  return state.selectedBenefit;
}
